module.exports = __webpack_public_path__ + "img/8de1a3ae947244da93fdbb971ab0343a-1440.a8baac3c.jpg";